import { render, staticRenderFns } from "./GalleryModel.vue?vue&type=template&id=37e2422c"
import script from "./GalleryModel.vue?vue&type=script&lang=js"
export * from "./GalleryModel.vue?vue&type=script&lang=js"
import style0 from "./GalleryModel.vue?vue&type=style&index=0&id=37e2422c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports